// imports section Start
import React, { useState, useEffect, useRef, createContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  useMediaQuery,
  Grid,
  IconButton,
  Tabs,
  Tab,
  Dialog,
  DialogContent,
  CircularProgress,
  Alert,
  Drawer,
  Pagination,
  tabsClasses,
  Button,
} from "@mui/material";
// import Tabs, { tabsClasses } from "@mui/material/Tabs";
import ListIcon from "@mui/icons-material/List";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import CashierItemCard from "../../components/cashier/cashier/CashierItemCard";
import CashierCategory from "../../components/cashier/cashier/CashierCategory";
import Header from "../../components/common/Header";
import CashierSummary from "../../components/cashier/cashier/CashierSummary";
import CashierPayment from "../../components/cashier/cashier/CashierPayment";
import { BASEURL, IMAGEBASEURL } from "../../config/Config";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import { COMMON_API_02, PARAMETER_API_01, SETTINGS_API_21 } from "../../api/ApiModel";
import {
  addCashierItemToCart,
  clearCashierCart,
} from "../../store/ReduxCashierCartReducer";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
  CON_STATUS_USER,
} from "../../utils/sys/Constants";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import { ADD_TO_CART } from "../../utils/sys/Messages";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { resetVouchers } from "../../store/ReduxVoucherSlice";
import { clearSlips } from "../../store/ReduxSlipSlice";
import { clearCheque } from "../../store/ReduxChequeSlice";
import { resetCards } from "../../store/ReduxCardSlice";
import dayjs from "dayjs";
import {
  clearLoyaltyData,
  setRedeemAmount,
} from "../../store/ReduxLoyaltySlice";
import { resetCreditNote } from "../../store/ReduxCreditNoteSlice";
import zIndex from "@mui/material/styles/zIndex";

// Create a context
export const CashierContext = createContext();

// imports section End

const Cashier = () => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const tabsRef = useRef(null);
  const dispatch = useDispatch();
  const [value, setValue] = useState("All");
  const [mainDrawerOpen, setMainDrawerOpen] = useState(false);
  const [orderData, setOrderData] = useState(null);
  const [categoryDialogOpen, setCategoryDialogOpen] = useState(false);
  const [allItems, setAllItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const [dynamicCategories, setDynamicCategories] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [data, setData] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Control Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [selectedOrderType, setSelectedOrderType] = useState(null);
  const [selectedWaiterTables, setSelectedWaiterTables] = useState([]);
  const [selectedWaiters, setSelectedWaiters] = useState([]);
  const location = useLocation();
  const [selectedAddons, setSelectedAddons] = useState([]);

  const [officerName, setOfficerName] = useState("");
  const [advanceAmount, setAdvanceAmount] = useState(0);
  const [cashTendered, setCashTendered] = useState(0);
  const [shippingCharge, setShippingCharge] = useState(0);
  const [adjustment, setAdjustment] = useState(0);
  const [grossAmount, setGrossAmount] = useState(0);
  const [rawDiscountValue, setRawDiscountValue] = useState("");
  const [discountType, setDiscountType] = useState("rate"); // Default to "rate"
  const [discountValue, setDiscountValue] = useState(""); // To store the entered discount value
  const [discountedTotal, setDiscountedTotal] = useState("0");
  const [deliveryDate, setDeliveryDate] = React.useState(dayjs());
  const [deliveryTime, setDeliveryTime] = React.useState(dayjs());
  const [contactPerson, setContactPerson] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [deliveryAddress, setDeliveryAddress] = useState("");
  const [table1Data, setTable1Data] = useState({});
  const [table2Data, setTable2Data] = useState([]);
  const [table3Data, setTable3Data] = useState([]);
  const [orderDetails, setOrderDetails] = useState({ items: [] });
  const [orderBillDetails, setOrderBillDetails] = useState({ items: [] });
  const { state } = useLocation();
  const navigate = useNavigate();
  // const { orderDetails, billDetails } = state || {};
  const cardList = useSelector((state) => state.cards.cardList);
  const chequeList = useSelector((state) => state.cheques.chequeList);
  const slipList = useSelector((state) => state.slips.slipList);
  const voucherList = useSelector((state) => state.vouchers.voucherList);
  const [responseValues, setResponseValues] = useState({
    advance: 0,
    afterCharge: 0,
    balance: 0,
    bank: 0,
    cash: 0,
    charge: 0,
    discount: 0,
    gift: 0,
    gross: 0,
    loyalty: 0,
    nettGross: 0,
    refundAmt: 0,
    shipping: 0,
    tax: 0,
    totNett: 0,
    totPaid: 0,
  });
  const [formData, setFormData] = useState({
    cash: { amount: "", clientname: "", refno: "" },
    card:
      cardList.length > 0
        ? cardList[0] // Use the first saved card
        : {
            cardname: "",
            cardaccountNumber: "",
            cardamount: 0,
            cardbank: "",
            cardbranch: "",
          },
    deposit: {
      slip:
        slipList.length > 0
          ? slipList[0]
          : {
              slipname: "",
              slipremark: "",
              slipamount: 0,
              slipbank: "",
              slipbranch: "",
            },
      cheque:
        chequeList.length > 0
          ? chequeList[0]
          : {
              chequename: "",
              chequeremark: "",
              chequeamount: 0,
              chequebank: "",
              chequebranch: "",
            },
    },
    redeem: {
      loyalty: { loyaltyamount: "", clientname: "" },
      voucher:
        voucherList.length > 0
          ? voucherList[0]
          : {
              voucherrefcode: "",
              vouchercode: "",
              voucherno: "",
              voucherbarcode: "",
              voucheramount: 0,
            },
    },
  });
  const [selectedTab, setSelectedTab] = useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // State to store the calculated totals
  const [cardTotalAmount, setCardTotalAmount] = useState(0);
  const [slipTotalAmount, setSlipTotalAmount] = useState(0);
  const [chequeTotalAmount, setChequeTotalAmount] = useState(0);
  const [voucherTotalAmount, setVoucherTotalAmount] = useState(0);
  const [addonsData, setAddonsData] = useState([]); // Store fetched addons
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20; // Number of items per page
const [datapara, setDatapara] = useState([]);
  useEffect(() => {
    // if (isLoggedIn && COMPCODE && LOCCODE && RESTCODE) {
    fetchData();
    fetchCategories();
    // fetchPromotionalItems();
    // }
  }, []);

  // Handle payment data from card payment (passed via location.state)
  useEffect(() => {
    if (state) {
      // Handle Table1 data
      if (state.Table1 && state.Table1.length > 0) {
        const table1Item = state.Table1[0];
        setTable1Data(table1Item);
        
        // Also update responseValues with Table1 data
        setResponseValues((prev) => ({
          ...prev,
          gross: table1Item.GROSS || 0,
          discount: table1Item.DISCOUNT || 0,
          nettGross: table1Item.NETTGROSS || 0,
          charge: table1Item.CHARGE || 0,
          afterCharge: table1Item.AFTERCHARGE || 0,
          tax: table1Item.TAX || 0,
          advance: table1Item.ADVANCE || 0,
          shipping: table1Item.SHIPPING || 0,
          bank: table1Item.BANK || 0,
          gift: table1Item.GIFT || 0,
          loyalty: table1Item.LOYALTY || 0,
          totNett: table1Item.TOTNETT || 0,
          cash: table1Item.CASH || 0,
          balance: table1Item.BALANCE || 0,
          totPaid: table1Item.TOTPAID || 0,
          refundAmt: table1Item.REFUNDAMT || 0,
        }));
      }
      
      // Handle Table2 data (tax details)
      if (state.Table2 && state.Table2.length > 0) {
        setTable2Data(state.Table2);
      }
      
      // Handle Table3 data
      if (state.Table3) {
        setTable3Data(state.Table3);
      }
    }
  }, [state]);

  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERREFCODE } =
    SYS_USER.USER_PARAM || {};

  // Handlers start
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  // Check if user is logged in
  const isLoggedIn = !!USERREFCODE;
  // Calculate totals dynamically whenever the lists change
  useEffect(() => {
    const calcCardTotal = cardList.reduce((total, card) => {
      const amount = parseFloat(card.cardamount) || 0;
      return total + amount;
    }, 0);
    setCardTotalAmount(calcCardTotal);

    const calcSlipTotal = slipList.reduce((total, slip) => {
      const amount = parseFloat(slip.slipamount) || 0;
      return total + amount;
    }, 0);
    setSlipTotalAmount(calcSlipTotal);

    const calcChequeTotal = chequeList.reduce((total, cheque) => {
      const amount = parseFloat(cheque.chequeamount) || 0;
      return total + amount;
    }, 0);
    setChequeTotalAmount(calcChequeTotal);
  }, [cardList, slipList, chequeList]); // Recalculate whenever these lists change

  // Calculate totals dynamically whenever the lists change
  useEffect(() => {
    const calcVoucherTotal = voucherList.reduce((total, voucher) => {
      const amount = parseFloat(voucher.voucheramount) || 0;
      return total + amount;
    }, 0);
    setVoucherTotalAmount(calcVoucherTotal);
  }, [voucherList]); // Recalculate whenever these lists change

  // Total amount across all categories
  const totalAmountBank = cardTotalAmount + slipTotalAmount + chequeTotalAmount;
  const totalAmountRedeem = voucherTotalAmount;

  // Handler for cash tendered input
  const handleCashTenderedChange = (e) => {
    handleNumericInput(e.target.value, setCashTendered);
  };

  const handleContinueToPayment = (order) => {
    setOrderData(order);
    setMainDrawerOpen(!mainDrawerOpen);
  };
  // Function to handle numeric inputs (advance and cash tendered)
  const handleNumericInput = (value, setState) => {
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value)) {
      setState(value);
    }
  };

  useEffect(() => {
    // Clear cart on page load
    // setOrderDetails({ items: [] });
    // setOrderBillDetails({ items: [] });
    setFormData("");
    dispatch(setRedeemAmount(""));
    dispatch(clearCashierCart());
    dispatch(resetVouchers());
    dispatch(clearSlips());
    dispatch(clearCheque());
    dispatch(resetCards());
    dispatch(clearLoyaltyData());
    dispatch(resetCreditNote());

    // navigate(location.pathname, { state: null });
  }, [dispatch]);

  const handleAddToCart = (item) => {
    if (isLoggedIn) {
      dispatch(addCashierItemToCart(item));
    } else {
      alert("Please log in to add items to the cart.");

      setSnackbarMessage(ADD_TO_CART);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    }
  };
  const handleNavigate = () => {
    navigate("/Placedorder"); // Replace '/placedorders' with your exact route path
  };

    const handleNavigatepending = () => {
    navigate("/Placedorderpending"); // Replace '/placedorders' with your exact route path
  };


  const handleSearch = (query) => {
    setSearchQuery(query);
    // Filter items based on the search query
    const filtered = allItems.filter(
      (item) =>
        item.MENUNAME.toLowerCase().includes(query.toLowerCase()) ||
        item.MENUREFCODE.toLowerCase().includes(query.toLowerCase())
    );
    // Sort items alphabetically by MENUNAME
    const sortedFilteredItems = filtered.sort((a, b) =>
      a.MENUNAME.localeCompare(b.MENUNAME)
    );
    setFilteredItems(sortedFilteredItems);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    filterItems(newValue);

    // Scroll to the selected tab
    const tabElement = tabsRef.current?.querySelector(
      `button[value="${newValue}"]`
    );
    tabElement?.scrollIntoView({ behavior: "smooth", inline: "center" });
  };

  const filterItems = (categoryCode) => {
    if (categoryCode === "All") {
      setFilteredItems(allItems);
    } else {
      setFilteredItems(
        allItems.filter((item) => item.MENUCATCODE === categoryCode)
      );
    }
  };
  const handleToggleDrawer = () => {
    setMainDrawerOpen(!mainDrawerOpen);
  };
  const handleCategoryDialogOpen = () => setCategoryDialogOpen(true);
  const handleCategoryDialogClose = () => setCategoryDialogOpen(false);

  const handleSelectCategory = (category) => {
    setValue(category.MENUCATCODE);
    filterItems(category.MENUCATCODE);
    setCategoryDialogOpen(false);
  };

  const handleViewOrder = (order) => setSelectedOrder(order);

  const sortedCategories = categories
    .filter((category) => category.MENUCATCODE !== "All")
    .sort((a, b) => a.MENUCATNAME.localeCompare(b.MENUCATNAME));

  const uniqueCategories = [
    { MENUCATCODE: "All", MENUCATNAME: "All" },
    ...dynamicCategories,
    ...sortedCategories,
  ].reduce((acc, category) => {
    if (!acc.some((cat) => cat.MENUCATCODE === category.MENUCATCODE)) {
      acc.push(category);
    }
    return acc;
  }, []);

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const calculateItemTotal = (item) => {
    // console.log("Item received for calculation:", item); // Debug log
    const rate = parseFloat(item.MENUPRICE || item.RATE || 0); // Check MENUPRICE first, then RATE
    const quantity = parseFloat(item.quantity || item.QTY || 1);
    // console.log(`Rate: ${rate}, Quantity: ${quantity}`); // Debug log
    return rate * quantity;
  };

  const handleDiscountValueChange = (event) => {
    const inputValue = event.target.value;

    // Allow numeric input, including decimals
    if (!/^(\d+(\.\d{0,2})?)?$/.test(inputValue)) {
      setError("Please enter a valid number with up to two decimal places");
      return;
    }

    const value = parseFloat(inputValue) || 0; // Parse input as a number or default to 0
    if (discountType === "amount") {
      if (value > grossAmount) {
        setError(`Discount amount cannot exceed ${grossAmount.toFixed(2)}`);
        setRawDiscountValue(grossAmount.toFixed(2)); // Limit to grossAmount
        setDiscountValue(100); // Set to 100%
      } else {
        setError("");
        setRawDiscountValue(inputValue); // Preserve user input
        setDiscountValue(((value / grossAmount) * 100).toFixed(8)); // Convert to percentage
      }
    } else if (discountType === "rate") {
      if (value > 100) {
        setError("Discount rate cannot exceed 100%");
        setDiscountValue(100); // Limit to 100%
      } else {
        setError("");
        setDiscountValue(inputValue); // Preserve user input
      }
    }
  };

  // Handlers end

  // API calls start
  const fetchData = async () => {
    try {
      const today = new Date();
      const formattedToday = `${today.getFullYear()}-${String(
        today.getMonth() + 1
      ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")} 23:59:59`;
      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        TODAY: formattedToday,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(COMMON_API_02, "GET", params);
      console.log("items", response);
      setAllItems(response);
      setFilteredItems(response);
    } catch (error) {
      setError(error);
    } finally {
      setData(true);
    }
  };

  const fetchCategories = async () => {
    try {
      const today = new Date();
      const formattedToday = `${today.getFullYear()}-${String(
        today.getMonth() + 1
      ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")} 23:59:59`;

      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        TODAY: formattedToday,
        MENUTYPECODE: CON_MENU_TYPE_CODE,
        STS: CON_STATUS_ACTIVE,
      };
      const categoryResponse = await externalgetApi(
        COMMON_API_02,
        "GET",
        params
      );
      console.log("categoryResponse", categoryResponse);
      setCategories(categoryResponse);
    } catch (error) {
      setError(error);
    }
  };

  const [showAgentButton, setShowAgentButton] = useState(false);
  const [showEditpriceButton, setShowEditpriceButton] = useState(false);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(PARAMETER_API_01, "get", {
          COMPCODE,
          lOCCODE: LOCCODE,
          ALLOWFOR: CON_STATUS_USER,
        });
        setDatapara(result);
        const para23 = result.find((item) => item.PARAID === 23);
        if (para23?.PARAVALUE === "Y") {
          setShowAgentButton(true);
        }
        const para13 = result.find((item) => item.PARAID === 13);
        if (para13?.PARAVALUE === "Y") {
          setShowEditpriceButton(true);
        }
        console.log("Data fetched successfully:", result);
      } catch (err) {
        setError(err);
      }
    };
  
    fetchData();
  }, []);
  
  // const fetchPromotionalItems = async () => {
  //   try {
  //     const result = await externalgetApi(SETTINGS_API_21, "get", {
  //       COMPCODE,
  //       LOCCODE,
  //       RESTCODE,
  //       SCHEDULEDATE: new Date().toISOString(),
  //       STS: CON_STATUS_ACTIVE,
  //     });
  //     console.log("promotions cas", result);
  //     setData(result);
  //     setIsLoading(false);
  //   } catch (err) {
  //     setError(err);
  //     setIsLoading(false);
  //   }
  // };
  // API calls end

  return (
    <>
      <Box sx={styles.root}>
        <Grid container sx={styles.height}>
          <Grid
            item
            xs={12}
            sm={12}
            md={7}
            lg={8}
            xl={8}
            sx={styles.screen_content}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.background.paper,
                width: "100%",
                padding: "12px 16px 0 16px",
                borderBottom: `2px solid ${theme.palette.stroke.main}`,
                boxShadow: 1,
              }}
            >
              <Header
                searchQuery={searchQuery}
                handleSearch={handleSearch}
                showSearch={true}
              />

              <Box ref={tabsRef} sx={styles.tabs_container}>
                {/* Fixed "All items" tab */}

                <Box sx={styles.tabs_list}>
                  <Box>
                    <Tab
                      key="All"
                      value="All"
                      label="All"
                      sx={
                        value === "All" ? styles.tab_selected : styles.tab_fixed
                      }
                      onClick={() => handleChange(null, "All")}
                    />
                  </Box>
                  {/* <Box sx={{ display: 'flex', alignItems: 'center' }}> */}
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    aria-label="scrollable auto tabs example"
                    scrollButtons
                    allowScrollButtonsMobile
                    sx={{
                      flexGrow: 1,
                      maxWidth: { xs: "25%", sm: "75%" },
                      [`& .${tabsClasses.scrollButtons}`]: {
                        "&.Mui-disabled": { opacity: 0.3 },
                      },
                    }}
                  >
                    {uniqueCategories
                      .filter((category) => category.MENUCATCODE !== "All")
                      .map((category) => (
                        <Tab
                          key={category.MENUCATCODE}
                          value={category.MENUCATCODE}
                          label={category.MENUCATNAME}
                          sx={
                            value === category.MENUCATCODE
                              ? styles.tab_selected
                              : styles.tab
                          }
                        />
                      ))}
                  </Tabs>
                </Box>
                <IconButton
                  sx={styles.header_tab_popup_icon}
                  onClick={handleCategoryDialogOpen}
                >
                  <ListIcon />
                </IconButton>
              </Box>
            </Box>
            <Box sx={styles.cards_container}>
              <Grid container spacing={2}>
                {data ? (
                  currentItems.map((item, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={3}
                      xl={3}
                      px={2}
                      key={index}
                    >
                      <CashierItemCard
                        cashierItem={item}
                        IMAGEBASEURL={IMAGEBASEURL}
                        onViewOrder={handleViewOrder}
                        onAddToCart={handleAddToCart}
                      />
                    </Grid>
                  ))
                ) : (
                  <Box sx={styles.progress_circular}>
                    <CircularProgress />
                  </Box>
                )}
                {error && (
                  <Grid item xs={12}>
                    <Alert severity="error">
                      Error fetching data: {error.message}
                    </Alert>
                  </Grid>
                )}
              </Grid>
            </Box>
           <Box
  sx={{
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    px: 2,
    py: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    boxShadow: 2,
    gap: 1,
    "@media (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
  }}
>
  {/* Wrap the buttons in a flex box */}
  <Box
    sx={{
      display: "flex",
      gap: 1,
      "@media (max-width: 600px)": {
        flexDirection: "column",
        width: "100%",
      },
    }}
  >
    <Button
      variant="contained"
      color="primary"
      onClick={handleNavigate}
      size="medium"
      sx={{
        ...styles.btn_primary,
        "@media (max-width: 600px)": {
          width: "100%",
        },
      }}
    >
      Placed Orders
    </Button>
 {showAgentButton && (
    <Button
      variant="contained"
      color="primary"
      onClick={handleNavigatepending}
      size="medium"
      sx={{
        ...styles.btn_primary,
        "@media (max-width: 600px)": {
          width: "110%",
        },
      }}
    >
    Pending Approvals
    </Button>
    )}
  </Box>

  {/* Pagination Section */}
  <Box
    sx={{
      "@media (max-width: 600px)": {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        mt: 2, // spacing below buttons
      },
    }}
  >
    <Pagination
      count={Math.ceil(filteredItems.length / itemsPerPage)}
      page={currentPage}
      onChange={(event, value) => setCurrentPage(value)}
      color="primary"
    />
  </Box>
</Box>

          </Grid>
          <CashierContext.Provider
            value={{
              selectedOrderType,
              setSelectedOrderType,
              selectedWaiterTables,
              setSelectedWaiterTables,
              selectedWaiters,
              setSelectedWaiters,
              cashTendered,
              setCashTendered,
              advanceAmount,
              setAdvanceAmount,
              handleCashTenderedChange,
              handleNumericInput,
              shippingCharge,
              setShippingCharge,
              adjustment,
              setAdjustment,
              grossAmount,
              setGrossAmount,
              discountType,
              setDiscountType,
              discountValue,
              setDiscountValue,
              discountedTotal,
              setDiscountedTotal,
              rawDiscountValue,
              setRawDiscountValue,
              table1Data,
              setTable1Data,
              table2Data,
              setTable2Data,
              table3Data,
              setTable3Data,
              handleDiscountValueChange,
              calculateItemTotal,
              deliveryDate,
              setDeliveryDate,
              deliveryTime,
              setDeliveryTime,
              contactPerson,
              setContactPerson,
              contactNumber,
              setContactNumber,
              deliveryAddress,
              setDeliveryAddress,
              responseValues,
              setResponseValues,
              formData,
              setFormData,
              totalAmountBank,
              cardTotalAmount,
              slipTotalAmount,
              chequeTotalAmount,
              totalAmountRedeem,
              voucherTotalAmount,
              orderDetails,
              setOrderDetails,
              orderBillDetails,
              setOrderBillDetails,
              officerName,
              setOfficerName,
              selectedAddons,
              setSelectedAddons,
              addonsData,
              setAddonsData,
            }}
          >
            <Grid
              container
              xs={12}
              sm={12}
              md={5}
              lg={4}
              xl={4}
              sx={{
                ...styles.cs_aside,
                marginLeft: mainDrawerOpen ? "-34.6%" : "0",
                [theme.breakpoints.up("md")]: {
                  marginLeft: mainDrawerOpen ? "-34.6%" : "0",
                },
                [theme.breakpoints.up("lg")]: {
                  marginLeft: mainDrawerOpen ? "-34.6%" : "0",
                },
                [theme.breakpoints.up("xl")]: {
                  marginLeft: mainDrawerOpen ? "-34.5%" : "0",
                },
              }}
            >
              <Box sx={{ position: "relative", height: "100%" }}>
                <IconButton
                  sx={styles.cs_aside_toggler_icon}
                  onClick={() => setMainDrawerOpen(!mainDrawerOpen)}
                >
                  <KeyboardDoubleArrowLeftIcon
                    sx={{
                      transform: mainDrawerOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "transform 0.3s",
                    }}
                  />
                </IconButton>

                <CashierSummary
                  sx={{ zIndex: "9999" }}
                  order={selectedOrder}
                  onContinueToPayment={handleContinueToPayment}
                  isPaymentOpen={mainDrawerOpen}
                />
              </Box>
              <Drawer
                anchor="right"
                variant="persistent"
                open={mainDrawerOpen}
                sx={styles.cs_aside_drawer}
              >
                <CashierPayment
                  orderData={orderData}
                  onContinueToPayment={handleContinueToPayment}
                />
              </Drawer>
            </Grid>
          </CashierContext.Provider>
        </Grid>

        <Dialog
          open={categoryDialogOpen}
          onClose={handleCategoryDialogClose}
          aria-labelledby="category-dialog-title"
        >
          {/* <DialogContent> */}
          <CashierCategory
            categories={categories}
            onSelectCategory={handleSelectCategory}
            onClose={handleCategoryDialogClose}
          />
          {/* </DialogContent> */}
        </Dialog>
      </Box>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity} // Dynamic severity (success or error)
      />
    </>
  );
};

export default Cashier;
